import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { ButtonTags } from './class-name-tags';
import { IconWrapper, StyledButton } from './styled';
export const getButtonType = (icon, children) => {
    if (icon && children) {
        return 'action';
    }
    if (!icon && children) {
        return 'text';
    }
    if (!children && icon) {
        return 'icon';
    }
    throw Error('Invalid button type');
};
export const Button = forwardRef(({ className, size = 'regular', disabled = false, variant = 'secondary', startIcon, endIcon, children, after, component, ...props }, ref) => {
    const type = getButtonType(startIcon ?? endIcon, children);
    const realComponent = component ?? 'button';
    return (React.createElement(StyledButton, { component: realComponent, className: classNames(ButtonTags.root, ButtonTags.variant(variant), ButtonTags.icon({ hasStartIcon: !!startIcon, hasEndIcon: !!endIcon }), size, type, { disabled }, className), disabled: disabled, type: "button", ref: ref, ...props },
        React.createElement("div", { className: ButtonTags.contentContainer },
            !!startIcon && (React.createElement(IconWrapper, { className: ButtonTags.iconWrapper }, startIcon)),
            children,
            !!endIcon && (React.createElement(IconWrapper, { className: ButtonTags.iconWrapper }, endIcon))),
        after));
});
//# sourceMappingURL=Button.js.map